import { useAllWidgets } from '../bff-api/bloomreach-recommendation/useAllWidgets';
import type { BloomreachWidget } from '../bff-api/bloomreach-recommendation/model/BloomreachWidget';
import type { WidgetRecommendationName } from '../constants/WidgetRecommendationName';

/**
 * Hook to get widget recommendations by name
 * @param names - Array of widget names to filter by
 * @returns Array of BloomreachWidgets from API
 *
 * @TODO: this hook should replace app/hooks/useRecommendations.tsx
 * @ticket SLTBE-6588
 *
 */
export const useWidgetRecommendations = (names: WidgetRecommendationName[]): BloomreachWidget[] => {
    const { data } = useAllWidgets();

    return data?.filter((widget) => names.includes(widget.name as WidgetRecommendationName)) ?? [];
};
